import { useSelector } from 'react-redux';
import { getUser } from 'redux/sagas/auth/selectors';
import { useBrand } from '../../../brand/hooks/useBrand';
import { createAffiliateLink } from 'utils/createAffiliateLink';
import { useCallback } from 'react';
import { useCopyToClipBoard } from 'utils/useCopyToClipBoard';

export const useShareLink = () => {
  const user = useSelector(getUser);
  const { brand } = useBrand();
  const affiliateLink = createAffiliateLink(user.refCode, brand);
  const copyToClipboard = useCopyToClipBoard();

  return useCallback(() => {
    copyToClipboard(affiliateLink);
  }, [affiliateLink, copyToClipboard]);
};
